import { useSelector } from "react-redux";
import { useStateList } from "./HandleInvoiceStateProvider";

// Custom Hook
export const useTaxabilityOptions = () => {
    const {partyType,invoiceEntry,data}=useStateList()
  
    
  const getCompany = useSelector(
    (state) => state?.companyReducer?.companyDetails
  );
  const companyType =
    getCompany?.relatedcompanydetailsnew?.[0]?.registrationtype;
 let partyTypeCD=invoiceEntry?.length===0?partyType:invoiceEntry?.partytypecd
 let stateValueCD=invoiceEntry?.length===0?data.placeOfSupply.value:invoiceEntry?.placeofsupply
 
 
  const gstOrCompositeRate = [
    {id:-1,rate:"NIL"},
    { id: 0, rate: "0%" },
    { id: 3, rate: "3%" },
    { id: 5, rate: "5%" },
  
    { id: 12, rate: "12%" },
    { id: 18, rate: "18%" },
    { id: 28, rate: "28%" },
      { id: 40, rate: "40%" },
  ];

  const compositeRate = [
    { id: 1, rate: "1%" },
    { id: 2, rate: "2%" },
    { id: 3, rate: "3%" },
    { id: 5, rate: "5%" },
    { id: 6, rate: "6%" },
  ];

  const allTaxabilityOptions = [
    { label: companyType == 3 && partyTypeCD==="CUSTOMER" ? "Composition-Taxable" : "Taxable", value: 1 },
    { label: "Exempted", value: 2 },
    { label: "Non-Taxable(Non-GST)", value: 3 },
    { label:(partyTypeCD==="SUPPLIER" && stateValueCD == 96) ? "Reverse Charge on Foreign Supplies":"GST Reverse Charge", value: 4 },
    { label: "Out of scope", value: 5 },

    {
      label:
        partyTypeCD === "SUPPLIER"
          ? "SEZ Supplies With Tax Payment"
          : "SEZ With Tax Payment",
      value: 6,
    },
    {
      label:
        partyTypeCD === "SUPPLIER"
          ? "SEZ Supplies Without Tax Payment"
          : "SEZ Without Tax Payment",
      value: 7,
    },
    { label: "Export With Tax Payment", value: 8 },
    { label: "Export Without Tax Payment", value: 9 },
  ];

  const taxabilityOptions = [
    { label: companyType == 3 && partyTypeCD==="CUSTOMER" ? "Composition-Taxable" : "Taxable", value: 1 },
    { label: "Exempted", value: 2 },
    { label: "Non-Taxable(Non-GST)", value: 3 },
    { label: "GST Reverse Charge", value: 4 },
    { label: "Out of scope", value: 5 },
  ];

  const compositeTaxability = [
    { label: companyType == 3 && partyTypeCD==="CUSTOMER" ? "Composition-Taxable" : "Taxable", value: 1 },
    { label: "Exempted", value: 2 },
    { label: "GST Reverse Charge", value: 4 },
    { label: "Non-Taxable(Non-GST)", value: 3 },
    { label: "Out of scope", value: 5 },
  ];
  const compositeTaxabilityForCustomer = [
    { label: companyType == 3 && partyTypeCD==="CUSTOMER"? "Composition-Taxable" : "Taxable", value: 1 },
    { label: "Exempted", value: 2 },
    // { label: "GST Reverse Charge", value: 4 },
    { label: "Non-Taxable(Non-GST)", value: 3 },
    { label: "Out of scope", value: 5 },
  ];

  const taxabilityOutsideIndia = partyTypeCD==="SUPPLIER"?[
    { label: "Reverse Charge on Foreign Supplies", value: 4 },
    { label: "Exempted", value: 2 },
    { label: "Non-Taxable(Non-GST)", value: 3 },
    { label: "Out of scope", value: 5 },
  ]:[
    { label: "Export With Tax Payment", value: 8 },
    { label: "Export Without Tax Payment", value: 9 },
  ];

  const compositeSupplierTaxability = [
    { label: "GST Reverse Charge", value: 4 },
  ];

  const unrSupplierTaxability = [
    { label: "Exempted", value: 2 },
    { label: "Non-Taxable(Non-GST)", value: 3 },
    { label: "GST Reverse Charge", value: 4 },
    { label: "Out of scope", value: 5 },
  ];

  const customerTaxabilityOptions = [
    {
      label:
        partyTypeCD === "SUPPLIER"
          ? "SEZ Supplies With Tax Payment"
          : "SEZ With Tax Payment",
      value: 6,
    },
    {
      label:
        partyTypeCD === "SUPPLIER"
          ? "SEZ Supplies Without Tax Payment"
          : "SEZ Without Tax Payment",
      value: 7,
    },
  ];

  return {
    gstOrCompositeRate,
    compositeRate,
    allTaxabilityOptions,
    taxabilityOptions,
    compositeTaxability,
    taxabilityOutsideIndia,
    compositeSupplierTaxability,
    unrSupplierTaxability,
    customerTaxabilityOptions,
    compositeTaxabilityForCustomer
  };
};
